import gql from 'graphql-tag'

export const SUBSCRIPTION_ASYNC_JOBS_REPORTS = `subscription AsyncJobsReports {
    asyncJobsReports {
      fileUrl
      filesUrl
      id
      name
      state
      payload {
        ... on SalesPayload {
          emails
          fileFormat
        }
        ... on CampaignMessageHistoryPayload {
          fileFormat
          emails
          channels
          campaignId
        }
        ... on ClientsSegmentationPayload {
          segmentationId
          groups
          fileFormat
          emails
        }
        ... on ConsumedCashbackReportPayload {
          filters {
            value
            predicate
            type
          }
          fileFormat
          emails
        }
        ... on ConsumedSalesPayload {
          unitsConfiguration {
            dataType
            value
          }
          units
          salesType
          offersScheduleId
          fileFormat
          emails
        }
        ... on ConsumedVouchersPayload {
          emails
          fileFormat
        }
        ... on DistributedCashbackReportPayload {
          filters {
            predicate
            type
            value
          }
          fileFormat
          emails
        }
        ... on OffersSchedulePayload {
          offersScheduleId
          offerType
          groupers
          fields
          emails
          fileFormat
        }
        ... on RaffleParticipantsReportPayload {
          raffleId
          fileFormat
          emails
        }
        ... on SalesProductsAnalysisReportPayload {
          emails
          fileFormat
          products
        }
        ... on WappContactsPayload {
          fileFormat
          emails
        }
        ... on CashbackUserCashbackAdjustmentPayload {
          emails
          fileFormat
        }
        ... on ScheduleOmniCampaignReportPayload {
          omniCampaignId
          userId
          accountId
          dbName
          messageError
        }
      }
      user {
        name
        id
      }
      createdAt
      emails
      expiresAt
      fileFormat
      title
    }
  }`

export const QUERY_ASYNC_JOBS = gql`
  query AsyncJobs($cursor: String!, $limit: Int!) {
    asyncJobs(cursor: $cursor, limit: $limit) {
      cursor
      asyncJobs {
        createdAt
        emails
        expiresAt
        fileFormat
        fileUrl
        filesUrl
        id
        name
        state
        title
        user {
          id
          name
        }
      }
    }
  }
`

export const MUTATION_RESEND_ASYNC_JOB = gql`
  mutation ResendAsyncJob($id: ID!) {
    resendAsyncJob(id: $id)
  }
`
